import { ContentSection, DataOverview, DescriptionList } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { getVehicleOptionalsDisplayName, getVehicleTransmissionTypesDisplayName } from "../../data/vehicle";
import { BrandType } from "@bus/models";

export const VehicleAddicionalCaracteristics = () => {
    const { t } = useTranslation(["summarypage"]);
    const { goToQuestionsStep, submitAnswersRequest } = useMatchMakerWizard();
    const { matchMakerAnswers } = submitAnswersRequest;
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    const getPowerTitle = () => {
        switch (brand) {
            case BrandType.VW:
            case BrandType.VWN:
            case BrandType.AUDI:
            case BrandType.SKODA:
                return t("summarypage:vehicle-addicional-characteristics.powerAlternative");
            default:
                return t("summarypage:vehicle-addicional-characteristics.power");
        }
    }
    return (
        <ContentSection.ComponentWrapper>
            <DataOverview
                href=""
                titleLevel={2}
                title={t("summarypage:vehicle-addicional-characteristics.title", {
                    brand: process.env.REACT_APP_WEBSITE_BRAND?.toUpperCase(),
                })}
                buttonLabel={t("summarypage:edit")}
                buttonProps={{
                    id: "VehicleAddicionalCharacteristicsSummaryEditButton",
                    onClick: (e) => {
                        e.preventDefault();
                        goToQuestionsStep(3, true);
                    },
                    tabIndex: 0,
                }}
                id="VehicleAddicionalCharacteristicsSummary"
            >
                {matchMakerAnswers && (
                    <DescriptionList grid>
                        <DescriptionList.Group
                            termText={t("summarypage:vehicle-addicional-characteristics.transmission")}
                        >
                            <DescriptionList.Detail>
                                <span id="VehicleAddicionalCharacteristicsTransmission">
                                    {matchMakerAnswers.transmissionType && matchMakerAnswers.transmissionType.length > 0
                                        ? matchMakerAnswers.transmissionType?.map((x, index) => {
                                            if (index + 1 < (matchMakerAnswers.transmissionType?.length ?? 0))
                                                return getVehicleTransmissionTypesDisplayName(x, t) + ", ";
                                            return getVehicleTransmissionTypesDisplayName(x, t);
                                        })
                                        : "-"}
                                </span>
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group termText={getPowerTitle()}>
                            <DescriptionList.Detail id="VehicleAddicionalCharacteristicsPower">
                                {matchMakerAnswers.minPower && matchMakerAnswers.maxPower
                                    ? matchMakerAnswers.minPower + "KW - " + matchMakerAnswers.maxPower + "KW"
                                    : "-"}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group termText={t("summarypage:vehicle-addicional-characteristics.equipment")}>
                            <DescriptionList.Detail id="VehicleAddicionalCharacteristicsEquipment">
                                {matchMakerAnswers.optionals && matchMakerAnswers.optionals.length > 0
                                    ? matchMakerAnswers.optionals?.map((x, index) => {
                                        if (index + 1 < (matchMakerAnswers.optionals?.length ?? 0))
                                            return getVehicleOptionalsDisplayName(x, t) + ", ";
                                        return getVehicleOptionalsDisplayName(x, t);
                                    })
                                    : "-"}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                    </DescriptionList>
                )}
            </DataOverview>
        </ContentSection.ComponentWrapper>
    );
};
